import React, { FC } from 'react';
import classNames from 'classnames';

import { Icon } from 'app/design-system/components/Icon';
import { Skeleton } from 'app/design-system/components/Skeleton';

import { favoriteIconSize, matchInfoSizes, matchNamesSizes, rightCellSizes } from './constants';

import styles from './NoDataSkeleton.module.scss';

type GridSkeletonsProps = {
  className?: string;
};

export const NoDataSkeleton: FC<GridSkeletonsProps> = ({ className }) => (
  <div className={classNames(styles.root, className)}>
    <div className={styles.details}>
      <Skeleton isAnimated={false}
                wrapperClassName={styles.matchNamesWrapper}
                skeletonSizes={matchNamesSizes} />
      <Skeleton isAnimated={false}
                wrapperClassName={styles.matchInfoWrapper}
                skeletonSizes={matchInfoSizes} />
      <Icon icon="favorite-active"
            className={styles.icon}
            size={favoriteIconSize} />
    </div>
    <Skeleton isAnimated={false}
              wrapperClassName={styles.rightCellWrapper}
              skeletonSizes={rightCellSizes} />
  </div>
);
